import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Refund} from '../refunds';
import {RefundService} from '../refunds.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message, SelectItem} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {Http, RequestOptions, ResponseContentType} from '@angular/http';
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {ItemsGroupsShowComponent} from "../../../setting/itemsGroups/itemsGroups-show/itemsGroups-show.component";
import {CurrenciesShowComponent} from "../../../setting/currencies/currencies-show/currencies-show.component";
import {formatDate} from "ngx-bootstrap/chronos";
import {CustomerService} from "../../../setting/customers/customer.service";
import {ItemService} from "../../../setting/items/items.service";
import {SupplierService} from "../../../setting/suppliers/supplier.service";
import {SuppliersShowComponent} from "../../../setting/suppliers/suppliers-show/suppliers-show.component";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {ItemsShowComponent} from "../../../setting/items/items-show/items-show.component";
import {PurchasesShowComponent} from "../../purchases/purchases-show/purchases-show.component";
import {JournalsShowComponent} from '../../../fin/journals/journals-show/journals-show.component';
import {InvoicesShowComponent} from '../../../pos/invoices/invoices-show/invoices-show.component';
import {ReturninvoicesShowComponent} from '../../../pos/returninvoices/returninvoices-show/returninvoices-show.component';
import {RecieptVouchersShowComponent} from '../../../fin/reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component';
import {ExpenseVouchersShowComponent} from '../../../fin/expense_vouchers/expense_vouchers-show/expense_vouchers-show.component';


@NgModule({
    imports: [CommonModule, FormsModule, DropdownModule,MyInputsModule, MessagesModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        RefundsShowComponent
    ],
    entryComponents: [
        RefundsShowComponent
    ],
    exports: [],
    providers: [SharedService, RefundService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-refunds-show',
    templateUrl: './refunds-show.component.html',
    styleUrls: ['./refunds-show.component.scss'],
    providers: [RefundService, ConfirmationService, MessageService, CustomerService,ItemService]
})

export class RefundsShowComponent implements OnInit, AfterViewInit {
  id: string;
  returninvoice= new Refund();
  @Input() refShow;
  bank: any[] = [];
  // picture:string;x
  applog: AppLogComponent;
  parent_name: any;
  @Input() scrId;
  modalRef: NgbModalRef;
  parent:any;
  parentpurch:any;
  @Input() delId;
  @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() modelName;


  statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];
  defVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];
  disc_typeVal = [{'val': 1, 'title': 'Percentage'}, {'val': 2, 'title': 'Cost'}];
  tax_typeVal = [{'val': 1, 'title': 'Yes'}, {'val': 0, 'title': 'No'}];

  allinvdetails: any[] = [];
  today = formatDate(new Date(),"YYYY-MM-DD");

  Selectedpaymentway: any = 0;
  Selectedpaymentdetails: any = "";
  Selectedpaymentamount: any = 0;
  restoreInv: any;
  inv_old_list_arr: any = [];
  payment_old_list_arr: any = [];
  allpaid: any=0.0;
  allremain: any=0.0;
  allquty:any = 0;
  allcost_b_tax:any = 0;
  allcost_a_tax:any = 0;
  alltaxes:any = 0;
  allcostsforone:any = 0;
  alldiscountvalue:any = 0;
  alltaxesother:any = 0;
  sumtaxes:any = 0;
  Selecteditem: any = "";
  Selecteditemcost: any = 0.0;
  Selecteditemquty: any = 0.0;
  Selecteditemtotal_b_tax: any;
  Selecteditemtotal_a_tax: any;
  Selecteditemtax: any;
  Selecteditemdetails: any = "";

  itemCount: any[] = [];
  itemCountPayment: any[] = [];


  invoice_arr: any[] = [];
  invoice_list_arr: any[] = [];
  invoice_payment_arr: any[] = [];
  allcostsforoneafterDisc:any = 0;



  deletedrow: any[] = [];
  deletedrowPayment: any[] = [];
  selectedrow: any[] = [];

  customers: any[] = [];
  customersselected: any[] = [];
  customersselected_old: any[] = [];

  Selected_items: any[] = [];
  Selected_payment: any[] = [];
  items: SelectItem[] = [];
  Selected_items_db: string[] = [];
  selectedItem: string[] = [];
  selectedPayment: string[] = [];
  invoices: any[] = [];
  invoicesshow: any[] = [];
  allitems: any = [];
  items_enhance: any = [];
  payment_enhance: any = [];
  //invoice_typeVal = [{'val': 1, 'title': 'type_cash'}, {'val': 2, 'title': 'type_notcash'}];
  invoice_typeVal: any;
  invoice_typeVal_old: any;

  form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private returninvoiceService: RefundService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private supplierService: SupplierService,
                private customerservice: CustomerService,
                private itemservice: ItemService,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        this.msgs =[];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));

        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
      this.sharedservice.setItemShow(RefundsShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},

        ]);
        this.sharedservice.setModelName('refunds');
      this.itemservice.getAllItems().subscribe(
        items => {
          this.allinvdetails = items.itemslist;
          this.allitems = items.itemslist;
          this.items_enhance = items.itemstable;
        });

    }
  showParent(){
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(SuppliersShowComponent, options);
    this.modalRef.componentInstance.scrId = this.parent;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
    });
  }
  showParentpurch(){
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(PurchasesShowComponent, options);
    this.modalRef.componentInstance.scrId = this.parentpurch;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }
  showItem(id){
    const options: NgbModalOptions = {

      beforeDismiss: () => {
        console.log("before dismiss");
        //
        return true;
      }
    };
    this.modalRef = this.modalService.open(ItemsShowComponent, options);
    this.modalRef.componentInstance.scrId = id;

    this.modalRef.result.then(() => {
      this.activeModal.dismiss('done');
    }, () => {
      console.log('Backdrop click')
    });
  }

    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.returninvoice;
        modalRef.componentInstance.rowId = '';

    }

    ngAfterViewInit() {
      if(!this.scrId && !this.oldData && !this.scrId) {
        this._editButton = document.getElementById('editButton');
        this._deleteButton = document.getElementById('deleteButton');
        this._newButton = document.getElementById('newButton');
        this._printButton = document.getElementById('printButton');
        this._searchButton = document.getElementById('searchButton');


        if (this._editButton) {
          this._editButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/refunds/edit', this.id]);
          });
        }
        if (this._deleteButton) {

          this._deleteButton.onclick = ((e: any) => {
            e.preventDefault();
            this.deleteRefund(this.returninvoice);
          });
        }
        if (this._newButton) {

          this._newButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/refunds']);
          });

        }
        if (this._searchButton) {
          this._searchButton.onclick = ((e: any) => {
            e.preventDefault();
            this.router.navigate(['/refunds/search']);
          });
        }

        if (this._printButton) {
          this._printButton.onclick = ((e: any) => {
            e.preventDefault();
            const params = new URLSearchParams();
            const userdata = JSON.parse(localStorage.getItem('currentUser'));
            const tokenapi = userdata.api_token;
            const options = new RequestOptions({responseType: ResponseContentType.Blob });
            params.set('token', tokenapi);
            window.open(appConfig.apiUrl + 'refunds/print/'+this.id+'?'+ params.toString() );
          });
        }
      }
    }

    ngOnInit() {
        this.returninvoiceService.getAllCurrencies().subscribe(
            bank => {
                this.bank = bank;
            });


      this.customerservice.getAllPurchaseInv().subscribe(
        customers => {
          this.invoicesshow = customers.invoiceshow;
          this.invoices = customers.invoiceslist;

        });




      this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.parent_name = params['invoice_parent_group'];


        });

        this.form = new FormGroup({
          id: new FormControl({value: '', disabled: true}),
          invoice_id: new FormControl({value: '', disabled: true}),
          customer_name: new FormControl({value: '', disabled: true}),
          customer_id: new FormControl({value: '', disabled: true}),
          total_free: new FormControl({value: '', disabled: true}),
          supplier_tax_num: new FormControl({value: '', disabled: true}),
          paid: new FormControl({value: '', disabled: true}),
          remain: new FormControl({value: '', disabled: true}),
          disc_type: new FormControl({value: '', disabled: true}),
          disc_value: new FormControl({value: '', disabled: true}),
          date_time: new FormControl({value: '', disabled: true}),
          time: new FormControl({value: '', disabled: true}),
          supplier_inv_num: new FormControl({value: '', disabled: true}),
          supplier_inv_date: new FormControl({value: '', disabled: true}),
          post_status: new FormControl({value: '', disabled: true}),
          collecting_customs_tax: new FormControl({value: '', disabled: true}),

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.newDatap = true;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }



            this.returninvoiceService.getById(this.id).subscribe(
              returninvoice => {
                this.invoice_arr = returninvoice.invoice;
                this.invoice_list_arr = returninvoice.itemsdetails;
                this.invoice_payment_arr = returninvoice.itemspayment;
                this.selectedItem = returninvoice.selecteditems;
                this.parent = returninvoice.invoice.supplier_id;
                this.parentpurch = returninvoice.invoice.invoice_no;
                this.id = returninvoice.invoice.id;
                this.returninvoice = returninvoice.invoice;

                this.form.patchValue({
                  id: returninvoice.invoice.id,
                  invoice_id: returninvoice.invoice.invoice_no,
                  invoice_type: returninvoice.invoice.invoice_type,
                  date_time: returninvoice.invoice.date_time,
                  price_offer: returninvoice.invoice.price_offer,
                  customer_id: returninvoice.invoice.supplier_id,
                  customer_name: returninvoice.invoice.supplier_name,
                  customer_type:returninvoice.invoice.customer_type,
                  delegate_type:returninvoice.invoice.delegate_type,
                  delegate_id:returninvoice.invoice.delegate_id,
                  delegate_name:returninvoice.invoice.delegate_name,
                  items_from_branch_id:returninvoice.invoice.items_from_branch_id,
                  total_free:returninvoice.invoice.total_free,
                  supplier_tax_num: returninvoice.invoice.supplier_tax_num,
                  paid: returninvoice.invoice.paid,
                  disc_type: returninvoice.invoice.disc_type,
                  disc_value: returninvoice.invoice.disc_value,
                  remain: returninvoice.invoice.remain,
                  import_date: returninvoice.invoice.import_date,
                  time: returninvoice.invoice.time,
                  supplier_inv_num: returninvoice.invoice.supplier_inv_num,
                  supplier_inv_date: returninvoice.invoice.supplier_inv_date,
                  post_status: returninvoice.invoice.post_status,
                });

                if(returninvoice.invoice.collecting_customs_tax == 1) {
                  this.form.controls['collecting_customs_tax'].setValue(true);
                } else {
                  this.form.controls['collecting_customs_tax'].setValue(false);
                }

                if(returninvoice.invoice.invoice_type == 1){
                  this.invoice_typeVal = "type_cash" ;

                }else{
                  this.invoice_typeVal =  "type_notcash" ;
                }

                this.supplierService.getAllSuppliers().subscribe(
                  sub => {
                    this.customers = sub.supplierslist;

                    this.customersselected=[this.customers[returninvoice.invoice.supplier_id]];

                  });


                for(let i=0; i<this.invoice_list_arr.length; i++){
                  let iserte = {item_id: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount ,  sumtaxs: ( parseFloat(this.invoice_list_arr[i].tax_ammount) + parseFloat(this.invoice_list_arr[i].other_tax_ammount) ).toFixed(2) , cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
                  this.Selected_items[i] = iserte;
                }
                this.itemCount = Array(this.Selected_items.length ).fill(2);

                for(let i=0; i<this.invoice_payment_arr.length; i++){

                  let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
                  this.Selected_payment[i] = iserte;
                }
                this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

                this.changallpaid();
                this.changeallremain();
              }, error => {
                console.log(error);
              }
            );


        }
        if (this.scrId) {
            this.oldData = false;
            this.newData = false;
            this.delId = false;

          this.returninvoiceService.getById(this.scrId).subscribe(
            returninvoice => {
              this.invoice_arr = returninvoice.invoice;
              this.invoice_list_arr = returninvoice.itemsdetails;
              this.invoice_payment_arr = returninvoice.itemspayment;
              this.selectedItem = returninvoice.selecteditems;

              this.id = returninvoice.invoice.id;
              this.returninvoice = returninvoice.invoice;
              this.parent = returninvoice.invoice.supplier_id;
              this.parentpurch = returninvoice.invoice.invoice_no;
              this.form.patchValue({
                id: returninvoice.invoice.id,
                invoice_id: returninvoice.invoice.invoice_no,
                invoice_type: returninvoice.invoice.invoice_type,
                date_time: returninvoice.invoice.date_time,
                price_offer: returninvoice.invoice.price_offer,
                customer_id: returninvoice.invoice.supplier_id,
                customer_name: returninvoice.invoice.supplier_name,
                customer_type:returninvoice.invoice.customer_type,
                delegate_type:returninvoice.invoice.delegate_type,
                delegate_id:returninvoice.invoice.delegate_id,
                delegate_name:returninvoice.invoice.delegate_name,
                items_from_branch_id:returninvoice.invoice.items_from_branch_id,
                total_free:returninvoice.invoice.total_free,
                supplier_tax_num: returninvoice.invoice.supplier_tax_num,
                paid: returninvoice.invoice.paid,
                disc_type: returninvoice.invoice.disc_type,
                disc_value: returninvoice.invoice.disc_value,
                remain: returninvoice.invoice.remain,
                import_date: returninvoice.invoice.import_date,
                time: returninvoice.invoice.time,
                supplier_inv_num: returninvoice.invoice.supplier_inv_num,
                supplier_inv_date: returninvoice.invoice.supplier_inv_date,
                post_status: returninvoice.invoice.post_status,
              });

              if(returninvoice.invoice.collecting_customs_tax == 1) {
                this.form.controls['collecting_customs_tax'].setValue(true);
              } else {
                this.form.controls['collecting_customs_tax'].setValue(false);
              }
              if(returninvoice.invoice.invoice_type == 1){
                this.invoice_typeVal = "type_cash" ;

              }else{
                this.invoice_typeVal =  "type_notcash" ;
              }

              this.supplierService.getAllSuppliers().subscribe(
                sub => {
                  this.customers = sub.supplierslist;

                  this.customersselected=[this.customers[returninvoice.invoice.supplier_id]];

                });


              for(let i=0; i<this.invoice_list_arr.length; i++){
                let iserte = {item_id: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount ,sumtaxs: (parseFloat(this.invoice_list_arr[i].other_tax_ammount) + parseFloat(this.invoice_list_arr[i].tax_ammount)).toFixed(2) ,  cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
                this.Selected_items[i] = iserte;
              }
              this.itemCount = Array(this.Selected_items.length ).fill(2);

              for(let i=0; i<this.invoice_payment_arr.length; i++){

                let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
                this.Selected_payment[i] = iserte;
              }
              this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

              this.changallpaid();
              this.changeallremain();
            }, error => {
              console.log(error);
            }
          );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.returninvoiceService.getTrashedById(this.delId).subscribe(
            returninvoice => {
              this.invoice_arr = returninvoice.invoice;
              this.invoice_list_arr = returninvoice.itemsdetails;
              this.invoice_payment_arr = returninvoice.itemspayment;
              this.selectedItem = returninvoice.selecteditems;
              this.parent = returninvoice.invoice.supplier_id;
              this.parentpurch = returninvoice.invoice.invoice_no;
              this.id = returninvoice.invoice.id;
              this.returninvoice = returninvoice.invoice;
              this.form.patchValue({
                id: returninvoice.invoice.id,
                invoice_id: returninvoice.invoice.invoice_no,
                invoice_type: returninvoice.invoice.invoice_type,
                date_time: returninvoice.invoice.date_time,
                price_offer: returninvoice.invoice.price_offer,
                customer_id: returninvoice.invoice.supplier_id,
                customer_name: returninvoice.invoice.supplier_name,
                customer_type:returninvoice.invoice.customer_type,
                delegate_type:returninvoice.invoice.delegate_type,
                delegate_id:returninvoice.invoice.delegate_id,
                delegate_name:returninvoice.invoice.delegate_name,
                items_from_branch_id:returninvoice.invoice.items_from_branch_id,
                total_free:returninvoice.invoice.total_free,
                supplier_tax_num: returninvoice.invoice.supplier_tax_num,
                paid: returninvoice.invoice.paid,
                disc_type: returninvoice.invoice.disc_type,
                disc_value: returninvoice.invoice.disc_value,
                remain: returninvoice.invoice.remain,
                import_date: returninvoice.invoice.import_date,
                time: returninvoice.invoice.time,
                supplier_inv_num: returninvoice.invoice.supplier_inv_num,
                supplier_inv_date: returninvoice.invoice.supplier_inv_date,

                post_status: returninvoice.invoice.post_status,
              });

              if(returninvoice.invoice.collecting_customs_tax == 1) {
                this.form.controls['collecting_customs_tax'].setValue(true);
              } else {
                this.form.controls['collecting_customs_tax'].setValue(false);
              }

              this.supplierService.getAllSuppliers().subscribe(
                sub => {
                  this.customers = sub.supplierslist;

                  this.customersselected=[this.customers[returninvoice.invoice.supplier_id]];

                });
              if(returninvoice.invoice.invoice_type == 1){
                this.invoice_typeVal = "type_cash" ;

              }else{
                this.invoice_typeVal =  "type_notcash" ;
              }

              for(let i=0; i<this.invoice_list_arr.length; i++){
                let iserte = {value: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount ,  sumtaxs: ( parseFloat(this.invoice_list_arr[i].tax_ammount) + parseFloat(this.invoice_list_arr[i].other_tax_ammount) ).toFixed(2)  , cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
                this.Selected_items[i] = iserte;
              }
              this.itemCount = Array(this.Selected_items.length ).fill(2);

              for(let i=0; i<this.invoice_payment_arr.length; i++){

                let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
                this.Selected_payment[i] = iserte;
              }
              this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);

              this.changallpaid();
              this.changeallremain();
            }, error => {
              console.log(error);
            }
          );
        }

        if (this.oldData && this.newData) {
          console.log("show",this.oldData,this.newData);

          this.restoreInv = this.oldData.invoice;
          this.restoreInv.inv_details = JSON.stringify(this.oldData.itemsdetails);
          this.restoreInv.inv_payment_details = JSON.stringify(this.oldData.itemspayment);
          this.inv_old_list_arr = this.oldData.itemsdetails;
          this.payment_old_list_arr = this.oldData.itemspayment;

          this.returninvoice = this.newData.invoice;
          this.parent = this.newData.invoice.supplier_id;
          this.parentpurch = this.newData.invoice_no;

          this.invoice_arr = this.newData.invoice;
          this.invoice_list_arr = this.newData.itemsdetails;
          this.invoice_payment_arr = this.newData.itemspayment;
          this.selectedItem = this.newData.selecteditems;
          this.selectedPayment= [];
          //this.returninvoice = returninvoice.invoice;



          this.customerservice.getAllPurchaseInv().subscribe(
            customers => {
              this.invoicesshow = customers.invoiceshow;
              this.invoices = customers.invoiceslist;

            });

            this.form.patchValue({
                id: this.newData.invoice.id,
              invoice_id: this.newData.invoice.invoice_no,
              invoice_type: this.newData.invoice.invoice_type,
              date_time: this.newData.invoice.date_time,
              price_offer: this.newData.invoice.price_offer,
              customer_id: this.newData.invoice.supplier_id,
              customer_name: this.newData.invoice.supplier_name,
              customer_type: this.newData.invoice.customer_type,
              delegate_type: this.newData.invoice.delegate_type,
              delegate_id: this.newData.invoice.delegate_id,
              delegate_name: this.newData.invoice.delegate_name,
              items_from_branch_id: this.newData.invoice.items_from_branch_id,
              total_free: this.newData.invoice.total_free,
              supplier_tax_num: this.newData.invoice.supplier_tax_num,
              paid: this.newData.invoice.paid,
              disc_type: this.newData.invoice.disc_type,
              disc_value: this.newData.invoice.disc_value,
              remain: this.newData.invoice.remain,
              import_date: this.newData.invoice.import_date,
              time: this.newData.invoice.time,
              supplier_inv_num: this.newData.invoice.supplier_inv_num,
              supplier_inv_date: this.newData.invoice.supplier_inv_date,
              post_status: this.newData.invoice.post_status,
            });

          if(this.newData.invoice.collecting_customs_tax == 1) {
            this.form.controls['collecting_customs_tax'].setValue(true);
          } else {
            this.form.controls['collecting_customs_tax'].setValue(false);
          }

          this.supplierService.getAllSuppliers().subscribe(
            sub => {
              this.customers = sub.supplierslist;
              this.customersselected=[this.customers[this.newData.invoice.supplier_id]];
              this.customersselected_old=[this.customers[this.oldData.invoice.supplier_id]];
            });

          if(this.newData.invoice.invoice_type == 1) {
            this.invoice_typeVal = "type_cash" ;
            this.invoice_typeVal_old = "type_cash" ;

          } else {
            this.invoice_typeVal =  "type_notcash" ;
            this.invoice_typeVal_old =  "type_notcash" ;
          }

          for(let i=0; i<this.invoice_list_arr.length; i++) {
            let iserte = {item_id: this.invoice_list_arr[i].item_id, inx: i , cost:this.invoice_list_arr[i].cost, quantity:this.invoice_list_arr[i].quantity ,costafterdiscount:this.invoice_list_arr[i].costafterdiscount , cost_before_tax:parseFloat(this.invoice_list_arr[i].cost_before_tax).toFixed(2) , itemtax:this.invoice_list_arr[i].itemtax , tax_ammount:this.invoice_list_arr[i].tax_ammount , othertaxs:this.invoice_list_arr[i].othertaxs , other_tax_ammount:this.invoice_list_arr[i].other_tax_ammount ,  sumtaxs: ( parseFloat(this.invoice_list_arr[i].tax_ammount) + parseFloat(this.invoice_list_arr[i].other_tax_ammount) ).toFixed(2)  , cost_after_tax:this.invoice_list_arr[i].cost_after_tax , details:this.invoice_list_arr[i].details};
            this.Selected_items[i] = iserte;
            this.selectedItem.push(this.invoice_list_arr[i].item_id);
          }
          this.itemCount = Array(this.Selected_items.length ).fill(2);

          for(let i=0; i<this.invoice_payment_arr.length; i++) {
            let iserte = {payment_type: this.invoice_payment_arr[i].payment_type , payment_details:this.invoice_payment_arr[i].payment_details , payment_amount:this.invoice_payment_arr[i].amount};
            this.Selected_payment[i] = iserte;

          }

          let arrlen = 0;
          if(this.invoice_payment_arr.length > this.payment_old_list_arr.length) {
            arrlen = this.invoice_payment_arr.length;
          } else {
            arrlen = this.payment_old_list_arr.length;
          }
          for(let i=0; i<arrlen; i++) {
            if( typeof  this.invoice_payment_arr[i] !== "undefined" &&  typeof  this.payment_old_list_arr[i] !== "undefined" &&  this.invoice_payment_arr[i].payment_type == this.payment_old_list_arr[i].payment_type && this.invoice_payment_arr[i].amount == this.payment_old_list_arr[i].amount ) {
              this.selectedPayment[i] = this.invoice_payment_arr[i];
            }
          }
          this.itemCountPayment = Array(this.invoice_payment_arr.length ).fill(2);
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if (userRoles.indexOf('pos.refunds.' + role) >= 0) {
            return true;
        }
        return false;
    }

    deleteRefund(returninvoice: Refund) {
      this.confirmationService.confirm({
        header: this.translate.instant('Confirm Delete'),
        message: this.translate.instant('Are you sure of delete ?'),
        icon: 'fa fa-trash',
        accept: () => {
          if (returninvoice) {
            this.returninvoiceService.delete(returninvoice.id).subscribe(
              res => {
                this.msgs = [];
                if(res.result){
                  this.msgs.push({
                    severity: 'success',
                    summary: '',
                    detail: this.translate.instant('Delete completed')
                  });
                  setTimeout(() => {
                    this.router.navigate(['/refunds']);
                  },1000);
                }
                else{
                  this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant(res.message)
                  });
                }
                localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                window.scroll(0,0);
              }
            );
          }
        }
      });
    }

    recoverEdit(returninvoice: Refund) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (returninvoice) {
                    this.returninvoiceService.update(returninvoice).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/refunds/show', returninvoice.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.returninvoiceService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted returninvoice recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/refunds/list']);
                        }
                    );
                }
            }
        });
    }


  showattachement(row_id: string) {
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
    }
  }


  changallpaid(){
    this.allpaid=0.0;
    for(let i=0; i<this.Selected_payment.length; i++){
      this.allpaid += parseFloat(this.Selected_payment[i].payment_amount);
    }
    let discv = this.form.controls['disc_value'].value;
    let disct =  this.form.controls['disc_type'].value;
    if(disct == 1){
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2) ;
    }else{
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }

    this.allremain = (parseFloat(this.allcost_a_tax )- parseFloat(this.alldiscountvalue )- parseFloat(this.allpaid )).toFixed(2);

  }
  changeallremain(){
    this.allremain=0.0;
    this.allquty=0.0;
    this.allcostsforone=0.0;
    this.allcostsforoneafterDisc=0.0;
    this.allcost_b_tax=0.0;
    this.allcost_a_tax=0.0;
    this.alltaxes=0.0;
    for(let i=0; i<this.Selected_items.length; i++) {
      console.log(i);
      if (typeof  this.Selected_items[i] !== "undefined") {

        this.allquty += parseFloat(this.Selected_items[i].quantity);
        this.allcostsforone += parseFloat(this.Selected_items[i].cost);
        this.allcostsforoneafterDisc +=  parseFloat(this.Selected_items[i].costafterdiscount);
        this.allcost_b_tax += parseFloat(this.Selected_items[i].cost_before_tax);
        this.allcost_a_tax += parseFloat(this.Selected_items[i].cost_after_tax);
        this.alltaxes += parseFloat(this.Selected_items[i].tax_ammount);
        this.alltaxesother += parseFloat(this.Selected_items[i].other_tax_ammount);

      }
    }

    this.allquty = parseFloat(this.allquty).toFixed(2);
    this.allcostsforone = parseFloat(this.allcostsforone).toFixed(2);
    this.allcostsforoneafterDisc =  parseFloat(this.allcostsforoneafterDisc).toFixed(2);
    this.allcost_b_tax = parseFloat(this.allcost_b_tax).toFixed(2);
    this.allcost_a_tax = parseFloat(this.allcost_a_tax).toFixed(2);
    this.alltaxes = parseFloat(this.alltaxes).toFixed(2);
    this.alltaxesother = parseFloat(this.alltaxesother).toFixed(2);
    this.sumtaxes = (parseFloat(this.alltaxes) + parseFloat(this.alltaxesother)).toFixed(2);

    let discv = this.form.controls['disc_value'].value;
    let disct =  this.form.controls['disc_type'].value;
    if(disct == 1){
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2) ;
    }else{
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }

    this.allremain = (parseFloat(this.allcost_a_tax )- parseFloat(this.allpaid )).toFixed(2);
  }

  changealldiscount(){
    let discv = this.form.controls['disc_value'].value;
    let disct =  this.form.controls['disc_type'].value;
    if(disct == 1) {
      this.alldiscountvalue = (parseFloat(this.allcost_a_tax) * parseFloat(discv) / 100).toFixed(2) ;
    } else {
      this.alldiscountvalue = parseFloat(discv).toFixed(2);
    }


    for(let i=0 ; i < this.Selected_items.length ; i++){
      let total_After_discount:any = (parseFloat(this.Selected_items[i].cost)).toFixed(2);
      if(disct == 1){
        let discval:any = (parseFloat(this.Selected_items[i].cost) * parseFloat(discv) / 100).toFixed(2)
        total_After_discount =  total_After_discount - discval;
      }else{
        total_After_discount = (parseFloat(total_After_discount) - parseFloat(discv)).toFixed(2);
      }
      this.Selected_items[i].costafterdiscount = (parseFloat(total_After_discount)).toFixed(2);
      this.Selected_items[i].cost_before_tax = (parseFloat(total_After_discount) * parseFloat(this.Selected_items[i].quantity)).toFixed(2);

    }
    this.changeallremain();
  }

  ConvertToInt(val , val2) {
    return parseFloat(val) + parseFloat(val2);
  }

  openpopup(doc,type) {
    console.log(doc);
    if(type === 0) {
      const modalRef = this.modalService.open(JournalsShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 2) {
      const modalRef = this.modalService.open(PurchasesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 3){
      //const modalRef = this.modalService.open(Retu);
    } else if(type === 4){
      const modalRef = this.modalService.open(InvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 5){
      const modalRef = this.modalService.open(ReturninvoicesShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 6){
      const modalRef = this.modalService.open(RecieptVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    } else if(type === 7){
      const modalRef = this.modalService.open(ExpenseVouchersShowComponent);
      modalRef.componentInstance.refShow = this.refShow;
      modalRef.componentInstance.scrId = doc;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/views/pro/refunds/refunds-show/refunds-show.component.ts